import en from '@angular/common/locales/en';
import { enUS } from 'date-fns/locale';
import {
    en_US,
    NZ_DATE_CONFIG,
    NZ_DATE_LOCALE,
    NZ_I18N,
} from 'ng-zorro-antd/i18n';

import { AppComponent } from './app.component';

import { ClipboardModule } from '@angular/cdk/clipboard';
import { LayoutModule } from '@angular/cdk/layout';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, isDevMode, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppRoutingModule } from './modules/app-routing.module';
import { NgZorroAntdModule } from './modules/ng-zorro-antd.module';

import { FireService } from './services/fire.service';
import { FuncService } from './services/functions-api.service';
import { BigQueryService } from './services/google-apis/bigquery/bigquery.service';
import { DirectQueryService } from './services/query/direct-query.service copy';

import { CompanyBillingComponent } from './dashboards/company-billing/company-billing.component';
import { CompanyMasterdashboardComponent } from './dashboards/company-masterdashboard/company-masterdashboard.component';
import { DevEChartsChomponent } from './dashboards/dev-echarts/dev-echarts.component';
import { MopaMetaEngagementComponent } from './dashboards/mopa-meta-engagement/mopa-meta-engagement.component';
import { MopaMetaSummaryComponent } from './dashboards/mopa-meta-summary/mopa-meta-summary.component';
import { MopaMetaEconomyComponent } from './dashboards/mopa-meta-economy/mopa-meta-economy.component';
import { MopaAbtestsComponent } from './dashboards/mopa-abtests/mopa-abtests.component';
import { MopaAdsComponent } from './dashboards/mopa-ads/mopa-ads.component';
import { MopaCampaignsChartsComponent } from './dashboards/mopa-campaigns-charts/mopa-campaigns-charts.component';
import { MopaCampaignsComponent } from './dashboards/mopa-campaigns/mopa-campaigns.component';
import { MopaCustomFunnelsComponent } from './dashboards/mopa-custom-funnels/mopa-custom-funnels.component';
import { MopaDecoFlowComponent } from './dashboards/mopa-deco-flow/mopa-deco-flow.component';
import { MopaDevicesComponent } from './dashboards/mopa-devices/mopa-devices.component';
import { MopaEngagementComponent } from './dashboards/mopa-engagement/mopa-engagement.component';
import { MopaFunnelsComponent } from './dashboards/mopa-funnels/mopa-funnels.component';
import { MopaRealtimeCloudSaveStatsComponent } from './dashboards/mopa-realtime-cloudsave-stats/mopa-realtime-cloudsave-stats.component';
import { MopaRealtimeStatsComponent } from './dashboards/mopa-realtime-stats/mopa-realtime-stats.component';
import { MopaResourceFlowComponent } from './dashboards/mopa-resource-flow/mopa-resource-flow.component';
import { MopaResourcesComponent } from './dashboards/mopa-resources/mopa-resources.component';
import { MopaResourcesDetailedComponent } from './dashboards/mopa-resources-detailed/mopa-resources-detailed.component';
import { MopaRetentionComponent } from './dashboards/mopa-retention/mopa-retention.component';
import { MopaSalesComponent } from './dashboards/mopa-sales/mopa-sales.component';
import { MopaSkadNetworkComponent } from './dashboards/mopa-skadnetwork/mopa-skadnetwork.component';
import { MopaUsersComponent } from './dashboards/mopa-users/mopa-users.component';

import { NsAutoHeightTableDirective } from './components/table-dashboard-item/ns-auto-height-table.directive';

import { DatePipe, registerLocaleData } from '@angular/common';
import { BiJobIdPipe } from './pipes/bi-job-id-pipe';
import { FsTimestampPipe } from './pipes/fs-timestamp-pipe';
import { ConsoleProvider } from './services/logger/logger-provider.service';
import {
    LOGGER_PROVIDERS,
    MIN_LOG_LEVEL,
} from './services/logger/logger.service';
import { LogLevel } from './services/logger/loglevel.enum';
import { QUERY_SERVICE_TOKEN } from './services/query/iquery.service';

import { AlertDataTextDashboardItemComponent } from './components/alert-data-text-dashboard-item/alert-data-text-dashboard-item.component';
import { AppVersionComponent } from './components/app-version/app-version.component';
import { CommonLegendComponent } from './components/common-legend/common-legend.component';
import { SavedDashboardViewLoaderComponent } from './components/dashboard/saved-dashboard-view/saved-dashboard-view-loader/saved-dashboard-view-loader.component';
import { SavedDashboardViewComponent } from './components/dashboard/saved-dashboard-view/saved-dashboard-view.component';
import { DataProjectSwitcherComponent } from './components/data-project-switcher/data-project-switcher.component';
import { DataTextComponent } from './components/data-text/data-text.component';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { EchartsCardComponent } from './components/echarts-card/echarts-card.component';
import { EchartsDashboardItemComponent } from './components/echarts-dashboard-item/echarts-dashboard-item.component';
import { KpiTilesComponent } from './dashboards/common/items/kpi-tiles/kpi-tiles.component';
import { TableViewComponent } from './components/echarts-dashboard-item/table-view/table-view.component';
import { MissingPageComponent } from './components/missing-page/missing-page.component';
import { MultipleSelectComponent } from './components/multiple-select/multiple-select.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { PlainMultiselectComponent } from './components/plain-multiselect/plain-multiselect.component';
import { RevenueControlsComponent } from './components/revenue-controls/revenue-controls.component';
import { RoyaltiesComponent } from './components/royalties-raport/royalties.component';
import { TableDashboardItemComponent } from './components/table-dashboard-item/table-dashboard-item.component';
import { FilterCategoryDashboardItemComponent } from './dashboards/common/items/filter/category-filter-dashboard-item/category-filter-dashboard-item.component';
import { FilterSelectorComponent } from './dashboards/common/items/filter/filter-selector/filter-selector.component';
import { SegmentFilterComponent } from './dashboards/common/items/filter/segment-filter/segment-filter.component';
import { UpflitReferenceSegmentSelectorComponent } from './dashboards/common/items/filter/segment-filter/upflit-reference-segment-selector/upflit-reference-segment-selector.component';
import { StringInputFilterDashboardItemComponent } from './dashboards/common/items/filter/string-input-filter/string-input-filter.component';
import { CheckboxComponent } from './dashboards/common/items/setting/checkbox/checkbox.component';
import { MultiSelectComponent } from './dashboards/common/items/setting/multi-select/multi-select.component';
import { SingleSelectComponent } from './dashboards/common/items/setting/single-select/single-select.component';
import { StringInputSettingComponent } from './dashboards/common/items/setting/string-input-setting/string-input-setting.component';
import { ToggleComponent } from './dashboards/common/items/setting/toggle/toggle.component';
import { JobsSummaryComponent } from './pages/jobs/jobs-summary/jobs-summary.component';
import { OrchestratorComponent } from './pages/jobs/orchestrator/orchestrator.component';
import { OrchestratorsComponent } from './pages/jobs/orchestrators/orchestrators.component';
import { LoginComponent } from './pages/login/login.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

registerLocaleData(en);

@NgModule({
    declarations: [
        // pipes
        FsTimestampPipe,
        BiJobIdPipe,

        AppComponent,
        AppVersionComponent,
        DataProjectSwitcherComponent,
        CheckboxComponent,
        DatePickerComponent,
        LoginComponent,
        MultipleSelectComponent,
        MissingPageComponent,
        SegmentFilterComponent,
        SingleSelectComponent,
        MultiSelectComponent,
        ToggleComponent,
        UnauthorizedComponent,
        EchartsCardComponent,
        EchartsDashboardItemComponent,
        KpiTilesComponent,
        FilterCategoryDashboardItemComponent,
        RevenueControlsComponent,
        AlertDataTextDashboardItemComponent,
        DataTextComponent,
        PlainMultiselectComponent,

        // dashboards and dashboard elements
        CompanyBillingComponent,
        CompanyMasterdashboardComponent,
        DevEChartsChomponent,
        MopaMetaEngagementComponent,
        MopaMetaSummaryComponent,
        MopaMetaEconomyComponent,
        MopaAbtestsComponent,
        MopaAdsComponent,
        MopaCampaignsComponent,
        MopaCampaignsChartsComponent,
        MopaCustomFunnelsComponent,
        MopaDecoFlowComponent,
        MopaDevicesComponent,
        MopaEngagementComponent,
        MopaFunnelsComponent,
        MopaRealtimeStatsComponent,
        MopaRealtimeCloudSaveStatsComponent,
        MopaResourceFlowComponent,
        MopaResourcesComponent,
        MopaResourcesDetailedComponent,
        MopaRetentionComponent,
        RoyaltiesComponent,
        MopaSalesComponent,
        MopaSkadNetworkComponent,
        MopaUsersComponent,
        NavbarComponent,
        CommonLegendComponent,
        TableDashboardItemComponent,
        NsAutoHeightTableDirective,
        JobsSummaryComponent,
        OrchestratorsComponent,
        OrchestratorComponent,
        TableViewComponent,
        StringInputFilterDashboardItemComponent,
        FilterSelectorComponent,
        SavedDashboardViewLoaderComponent,
        SavedDashboardViewComponent,
        UpflitReferenceSegmentSelectorComponent,
        StringInputSettingComponent,
    ],
    imports: [
        AppRoutingModule,
        // BrowserAnimationsModule,
        NoopAnimationsModule,
        BrowserModule,
        FormsModule,
        LayoutModule,
        NgZorroAntdModule,
        NgxEchartsModule.forRoot({
            echarts: () => import('echarts'),
        }),
        ReactiveFormsModule,
        ClipboardModule,
        HttpClientModule,
    ],
    providers: [
        FireService,
        {
            provide: APP_INITIALIZER,
            useFactory: (fire: FireService) => async () => {
                await fire.init();
            },
            deps: [FireService],
            multi: true,
        },
        // BigQuery requires custom factory
        {
            provide: BigQueryService,
            useFactory: (http: HttpClient, func: FuncService) =>
                new BigQueryService(
                    http,
                    async () => await func.getQueryToken()
                ),
            deps: [HttpClient, FuncService],
        },
        // choose IQueryService here
        { provide: QUERY_SERVICE_TOKEN, useExisting: DirectQueryService },
        // { provide: QUERY_SERVICE_TOKEN, useExisting: FuncQueryService },

        { provide: NZ_I18N, useValue: en_US },
        {
            provide: NZ_DATE_CONFIG,
            useValue: {
                firstDayOfWeek: 1, // week starts on Monday (Sunday is 0)
            },
        },
        { provide: NZ_DATE_LOCALE, useValue: enUS },
        // required by FsTimestampPipe
        DatePipe,
        { provide: LOGGER_PROVIDERS, useClass: ConsoleProvider, multi: true },
        {
            provide: MIN_LOG_LEVEL,
            useValue: isDevMode() ? LogLevel.DEBUG : LogLevel.WARNING,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
